import cx from "classnames";
import { getConsole } from "lib/getConsole";
import React from "react";
import { Checkbox } from "../Checkbox";
import styles from "./CheckboxGroup.scss";
const console = getConsole("common", "CheckboxGroup");

export class CheckboxGroup extends React.PureComponent {
  onChange = (key) => {
    const { selected, onChange, onToggleItem } = this.props;
    // two interfaces are provided for handing CheckboxGroup changes.
    //
    // onChange is the "batteries included" version that handles manipulation
    // of the selection set for you and hands it back in the callback
    //
    // onToggleItem just passes toggle events to the parent, giving more
    // granular control over how to handle changes
    if (onChange && onToggleItem) {
      console.warn(
        "both the onChange and onToggleItem callbacks were specified to CheckboxGroup, this is most likely a bug"
      );
    }
    if (onToggleItem) {
      onToggleItem(key);
      return;
    }
    if (onChange) {
      const newSelected = selected.has(key) ? selected.remove(key) : selected.add(key);
      onChange(newSelected);
    }
  };

  render() {
    const { options, selected, horizontal, className, style, onClickOption } = this.props;
    return (
      <div className={cx(styles.CheckboxGroup, className)} style={style}>
        {options
          .map((value, key) => (
            <Checkbox
              onClickOption={onClickOption}
              horizontal={horizontal}
              key={key}
              checked={selected.has(key)}
              label={value}
              onChange={this.onChange.bind(this, key)}
            />
          ))
          .toIndexedSeq()}
      </div>
    );
  }
}
